export default __webpack_public_path__ + "static/media/waitlist-blue.da1c2594.svg";